(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name PetitionService
     *@description
     *Servicio de peticiones de piezas de almacén. Los desplegables de la
     *requisición usan los mismos endpoints que la requisición del Kanban,
     *salvo el de personas, que va paginado.
     */

    angular
        .module('appback')
        .factory('PetitionService', PetitionService);

    PetitionService.$inject = ["$http"];

    function PetitionService($http) {

        var service = {
            getData: getData,
            getWarehouses: getWarehouses,
            getCostCenters: getCostCenters,
            getPetitionProducts: getPetitionProducts,
            getServiceProducts: getServiceProducts,
            getUsers: getUsers,
            createRequisition: createRequisition,
            getPendingPetitions: getPendingPetitions,
            resolvePetition: resolvePetition,
            getReturnablePetitions: getReturnablePetitions,
            createReturn: createReturn
        };

        return service;

        function getData() {
            return $http.get('/backend/petition/data').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function getWarehouses() {
            return $http.get('/backend/kanban/get-warehouses').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function getCostCenters() {
            return $http.get('/backend/kanban/get-cost-centers').then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function getPetitionProducts(search, offset, limit, warehouseId) {
            return $http.get('/backend/kanban/get-petition-products', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 30,
                    warehouse: warehouseId || ''
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function getServiceProducts(search, offset, limit) {
            return $http.get('/backend/kanban/get-service-products', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 50
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function getUsers(search, offset, limit) {
            return $http.get('/backend/petition/users', {
                params: {
                    search: search || '',
                    offset: offset || 0,
                    limit: limit || 30
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        function createRequisition(payload) {
            return $http.post('/backend/petition/create-requisition', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        // Peticiones pendientes de aceptar o rechazar, paginadas (page desde 1).
        function getPendingPetitions(page, pageSize) {
            return $http.get('/backend/petition/pending', {
                params: {
                    page: page || 1,
                    pageSize: pageSize || 10
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        // Peticiones completadas que se pueden devolver, paginadas.
        function getReturnablePetitions(offset, limit) {
            return $http.get('/backend/petition/returnable', {
                params: {
                    offset: offset || 0,
                    limit: limit || 10
                }
            }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        // Devolución de una petición completada: {request_id, quantity, requested_by_id, observations}.
        function createReturn(payload) {
            return $http.post('/backend/petition/create-return', payload).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }

        // Acepta (accept = true) o rechaza una petición pendiente.
        function resolvePetition(id, accept) {
            return $http.post('/backend/petition/resolve', { id: id, accept: !!accept }).then(function (response) {
                return response.data;
            }, function (error) {
                return error;
            });
        }
    }
})();
